const mediaQuery = window.matchMedia('(max-width: 800px)');
const isMobileBreakpoint = mediaQuery.matches;

// validate links for the card widget
function validateLinks(data, x, item) {
  const { URL, PurchaseURL } = data.items[x];
  const hasValidLink = PurchaseURL || URL;

  // if the card doesn't have any link remove the atributes and add the class
  if (!hasValidLink) {
    if (!isMobileBreakpoint) {
      item.addClass('void-link');
    }
    item.removeAttr('href');
    item.removeAttr('target');
  }
}

function modifyLinkBehavior(widgetData, cards) {
  cards.each(function (x) {
    const card = $(this);
    const cardIsLink = card.is('a');
    const buttons = card.find('.buttonwrap');
    const cardHasButton = buttons.children().length > 0;

    switch (true) {
      case cardIsLink:
        validateLinks(widgetData, x, card);
        if (isMobileBreakpoint) {
          // remove the buttonwrap when is mobile
          buttons.remove();
        }
        break;
      case cardHasButton:
        validateLinks(widgetData, x, card);
        break;

      default:
        if (!isMobileBreakpoint) {
          card.addClass('void-link');
        }
        break;
    }
  });
}

// function to detect local url
function isLocalUrl(urlToCheck) {
  return urlToCheck !== null && urlToCheck.includes(SITEBASEURL);
}

export { modifyLinkBehavior, isMobileBreakpoint, isLocalUrl };
